import { ArrayLoading } from '@/store/types'

import { loading, none } from '@/store/constants'
import {
  ActiveImageFolder, ImageFolder, Image, ImageUsage, ActiveImage,
} from './types'

import { blankEditBase, active } from '@/store/editor/constants'

import _ from 'lodash'

// TODO: Permission for each role by default!
export const blankImageFolder: ImageFolder = _.merge({
  FolderId: -1,
  FolderName: '',
  ChildFolders: [],
  Images: [],
}, blankEditBase)

export const loadingImageFolder: ArrayLoading<ImageFolder> = _.assign([], blankImageFolder, loading)

export const noneDocumentFolder: ImageFolder = _.assign({}, blankImageFolder, none)

export const activeImageFolderNone: ActiveImageFolder = _.assign({}, blankImageFolder, active, none)

export const blankImage: Image = _.assign({ ImageId: -1, ImageName: '', FullPath: '', ContentType: '', Height: 0, Width: 0 }, blankEditBase)

export const noneImage: Image = _.assign({}, blankImage, none)

export const activeImageNone: ActiveImage = _.assign({}, noneImage, active, none)

export const blankImageUsage: ImageUsage = _.assign({ ImageId: -1, Path: '', ImagePath: '', Products: [], Categories: [], SectionImages: [], Sites: [], SiteSectionImages: [], ModelImages: [] }, blankEditBase)
